// Keeps the last fetched Vocabulary rows (site label renames), so labels
// render immediately on a page refresh while the fresh copy is fetched.
// The payload is a few rows, so localStorage is fine here (cf. refListCache.js).

const VOCABULARY_KEY = "vocabulary";

export const loadCachedVocabulary = () => {
  try {
    const cached = JSON.parse(localStorage.getItem(VOCABULARY_KEY));
    return Array.isArray(cached) ? cached : [];
  } catch {
    return [];
  }
};

export const saveCachedVocabulary = (rows) => {
  try {
    localStorage.setItem(VOCABULARY_KEY, JSON.stringify(rows ?? []));
  } catch (error) {
    console.error("Failed to cache vocabulary:", error);
  }
};

export const clearCachedVocabulary = () => {
  try {
    localStorage.removeItem(VOCABULARY_KEY);
  } catch {
    // Storage unavailable — nothing to clear.
  }
};
